export default {"src":"/_next/static/media/clown_40.afce9e05.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};